import React, { useEffect, useState } from 'react';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './App.css';
import Header from './Header';
import BotCard from './BotCard';
import { SubmitBotForm } from './components';
import { CheckBox, Button} from '@mikugg/ui-kit';
import trackEvent from './libs/trackEvent';

const BOTS_URL = 'https://bots.miku.gg/static/bots.json';

function checkURL(endpointType, url) {
  if (endpointType === 'oobabooga') {
    const regex = /^https:\/\/([\w-]+\.)*trycloudflare\.com\/api$/;
    return regex.test(url);
  } else if (endpointType === 'openai') {
    return url.startsWith('sk-');
  }

  return true;
}

function getSettingsFromStorage() {
  const DEFAULT_SETTINGS = {
    endpoints: {
      'default': '',  
      'oobabooga': '',
      'openai': '',
    },
    selectedEndpoint: 'default',
    strategy: 'alpaca',
  };

  try {
    return JSON.parse(localStorage.getItem('mikugg_settings')) || DEFAULT_SETTINGS;
  } catch {
    return DEFAULT_SETTINGS;
  }
}

const filterFns = new Map([
  ['sfw', (bot) => !(bot?.tags?.includes('nsfw') || bot?.tags?.includes('NSFW'))],
  ['multi-scenario', (bot) => !!(bot?.tags?.includes('multi-scenario'))],
  ['multi-emotion', (bot) => !!(bot?.tags?.includes('multi-emotion'))],
])

function App() {
  const [bots, setBots] = useState([]);
  const [settings, _setSettings] = useState(getSettingsFromStorage());
  const isValid = checkURL(settings.selectedEndpoint, settings.endpoints[settings.selectedEndpoint]);
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [_filters, setFilters] = useState([]);
  const filters = new Set(_filters);

  const setSettings = (_settings) => {
    localStorage.setItem('mikugg_settings', JSON.stringify(_settings));
    _setSettings(_settings);
  }

  useEffect(() => {
    fetch(BOTS_URL)
      .then(response => response.json())
      .then(data => {
        setBots(data);
      })
      .catch(error => {
        console.error('Error fetching JSON file:', error);
      });
  }, []);

  return (
    <div className="App">
      <Header
        settings={settings}
        setSettings={setSettings}
        isValid={isValid}
        onUploadClick={() => setIsPopUpOpen(true)}
      />
      <ToastContainer />
      <div className="platform-ad">
        <div className="platform-ad__content">
          <div className="platform-ad__title">Migrate to miku.gg</div>
          <div className="platform-ad__description">This site is intended for testing purposes only. Check out our new platform for interacting with visual novels!</div>
        </div>
        <div className="platform-ad__action">
          <a href="https://miku.gg">
            <Button theme="gradient">
              Go to miku.gg
            </Button>
          </a>
        </div>
      </div>
      <div className="bot-list-header">
        <h2 className="bot-list-title">Latest Bots</h2>
        <div className="filters">
          {/* <CheckBox
            id="checkbox-multi-scenario"
            value={!filters.has('multi-scenario')}
            label="Multiple Scenarios"
            onChange={(event) => {
              if (event.target.checked) {
                filters.add('multi-scenario');
              } else {
                filters.delete('multi-scenario');
              }
              setFilters(Array.from(filters));
            }}
          />
          <CheckBox
            id="checkbox-multi-emotion"
            value={!filters.has('multi-emotion')}
            label="Multiple Outfits"
            onChange={(event) => {
              if (event.target.checked) {
                filters.add('multi-emotion');
              } else {
                filters.delete('multi-emotion');
              }
              setFilters(Array.from(filters));
            }}
          /> */}
          <CheckBox
            id="checkbox-nsfw"
            value={!filters.has('sfw')}
            label="Include NSFW"
            onChange={(event) => {
              if (event.target.checked) {
                filters.delete('sfw');
                trackEvent('nsfw_clicked', { nsfw: true });
              } else {
                filters.add('sfw');
                trackEvent('nsfw_clicked', { nsfw: false });
              }
              setFilters(Array.from(filters));
            }}
          />
        </div>
      </div>
      <div className="bot-list">
        {bots.sort((bot1, bot2) => {
          return (bot2?.date || 0) - (bot1?.date || 0);
        }).filter(bot => Array.from(filters).reduce((current, filter) => filterFns.get(filter)(bot) && current, true)).map((bot) => (
          <BotCard key={bot.id} bot={bot} settings={settings} isValid={isValid} />
        ))}
      </div>
      {
        isPopUpOpen && <SubmitBotForm isPopUpOpen={isPopUpOpen} setIsPopUpOpen={setIsPopUpOpen} />
      }
    </div>
  );
}

export default App;
